import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';

import { Filter } from '../common/Filter';
import { RadioButtonGroup } from '../../RadioButtonGroup';
import { InlineFilterGroup } from '../common/InlineFilterGroup';
import { InlineFilter } from '../common/InlineFilter';

interface IFromDeveloperOption {
  label: string;
  value: boolean | null;
}

const FROM_DEVELOPER_OPTIONS: IFromDeveloperOption[] = [
  { label: 'Неважно', value: null },
  { label: 'От застройщиков', value: true },
  { label: 'От агентов и частных лиц', value: false },
];

interface IOfferTypeProps {
  promo: boolean | null;
  specialPromoLabel: string | null;
  specialPromoActive: boolean | null;
  fromDeveloper: boolean | null;
  onPromoChange(value: boolean | null): void;
  onSpecialPromoChange(value: boolean | null): void;
  onFromDeveloperChange(value: boolean | null): void;
}

export const OfferType: React.FC<IOfferTypeProps> = ({
  promo,
  specialPromoLabel,
  specialPromoActive,
  fromDeveloper,
  onPromoChange,
  onSpecialPromoChange: onPikPromoChange,
  onFromDeveloperChange,
}) => {
  return (
    <Filter id="advancedFilter_offerType" label="Тип объявления">
      <InlineFilterGroup>
        <InlineFilter>
          <RadioButtonGroup
            options={FROM_DEVELOPER_OPTIONS}
            value={fromDeveloper}
            onChange={onFromDeveloperChange}
            spliced={false}
          />
        </InlineFilter>
        <InlineFilter>
          <Checkbox
            label="Скидки и акции"
            checked={!!promo}
            onChange={event => onPromoChange(event.target.checked ? true : null)}
          />
        </InlineFilter>
        {specialPromoLabel && (
          <InlineFilter>
            <Checkbox
              label={specialPromoLabel}
              checked={!!specialPromoActive}
              onChange={event => onPikPromoChange(event.target.checked ? true : null)}
            />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </Filter>
  );
};
